import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import type { TableColumn } from '@ipfabric/utils';
import { renderCellContentByType } from 'components/Table/cells/renderCellContentByType';
import type { TableCellContext } from 'components/Table/model/TableCellContext';
import { useLocale } from 'containers/App/LocaleContext';
import { LoaderAndText } from 'containers/LoaderAndText/LoaderAndText';
import type { FC } from 'react';
import type { RowDetailData } from './useRowDetailData';

interface Props {
  data: RowDetailData;
  context: TableCellContext;
}

export const TableRowDetailTable: FC<Props> = (props) => {
  const visibleColumns = props.data.columns.filter((c) => c.hidden !== true);
  const rowDetailMsg = useLocale().table.rowDetail;
  const renderColumn = (column: TableColumn<any>, index: number) => {
    if (!props.data.item) {
      return null;
    }

    const cell = renderCellContentByType(column, {
      row: props.data.item,
      context: props.context,
      index,
      severity: null,
    });

    return (
      <div
        className='table-row-detail__table-row flex justify-between'
        key={column.key}
      >
        <div>
          <Tooltip content={column.description}>
            <span className='text-bluegray-600 text-xs'>{column.title}</span>
          </Tooltip>
        </div>
        <div className='text-right font-semibold'>{cell.content}</div>
      </div>
    );
  };

  if (props.data.loadingState === 'LOADING') {
    return <LoaderAndText />;
  }

  if (!props.data.item) {
    return (
      <div className='table-row-detail__table-row text-bluegray-600 italic'>
        {rowDetailMsg.noDataAvailable}
      </div>
    );
  }

  return <>{visibleColumns.map((c) => renderColumn(c, 0))}</>;
};
